import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Input, Button, DatePicker, InputNumber, Space, Typography, Divider } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';

import api from './../../../api';
import Dashheader from '../Dashheader/Dashheader.jsx';


const { Title } = Typography;

const Addtowerstep9 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { towerId } = location.state || {};

  const [projectStartDate, setProjectStartDate] = useState(null);
const [projectEndDate, setProjectEndDate] = useState(null);


  const storedData = JSON.parse(localStorage.getItem('AdminDetails')) || {};
  const managementId = storedData?.data?.data?._id || null;

  const [phases, setPhases] = useState([
    {
      name: '',
      startDate: null,
      endDate: null,
      isActive: true,
      scheme: [{ percent: 0, days: 0 }],
    },
  ]);

  useEffect(() => {
    console.log('📦 Received towerId in Step 9:', towerId);
  }, [towerId]);

  const handleAddPhase = () => {
    setPhases(prev => [
      ...prev,
      {
        name: '',
        startDate: null,
        endDate: null,
        isActive: true,
        scheme: [{ percent: 0, days: 0 }],
      },
    ]);
  };

  const handleRemovePhase = (index) => {
    const updated = [...phases];
    updated.splice(index, 1);
    setPhases(updated);
  };

  const handlePhaseChange = (index, key, value) => {
    const updated = [...phases];
    updated[index][key] = value;
    setPhases(updated);
  };

  const handleSchemeChange = (phaseIndex, schemeIndex, key, value) => {
    const updated = [...phases];
    updated[phaseIndex].scheme[schemeIndex][key] = value;
    setPhases(updated);
  };

  const handleAddScheme = (phaseIndex) => {
    const updated = [...phases];
    updated[phaseIndex].scheme.push({ percent: 0, days: 0 });
    setPhases(updated);
  };

  const handleRemoveScheme = (phaseIndex, schemeIndex) => {
    const updated = [...phases];
    updated[phaseIndex].scheme.splice(schemeIndex, 1);
    setPhases(updated);
  };

  const handleSubmit = async () => {
    if (!projectStartDate || !projectEndDate) {
  alert('Please select both project start and end dates.');
  return;
}
    const body = {
  towerId,
  createdBy: managementId,
  isActive: true,
  projectStartDate: projectStartDate?.toISOString(),
  projectEndDate: projectEndDate?.toISOString(),
  phases: phases.map(phase => ({
    name: phase.name,
    startDate: phase.startDate?.toISOString(),
    endDate: phase.endDate?.toISOString(),
    isActive: true,
    scheme: phase.scheme.map(s => ({
      percent: s.percent,
      days: s.days,
    })),
  })),
};


    console.log('📤 Submitting:', body);

    try {
      const response = await api.addTowersStep9(body);
      console.log('✅ API Response:', response);
      alert('Phases submitted successfully!');

      // Optionally navigate to next step or dashboard
      navigate('/login/dashboard');
    } catch (error) {
      console.error('❌ Submission failed:', error);
      alert('Submission failed.');
    }
  };

  return (
    <>
      <Dashheader />
      <div className="addtowers">
        <Title level={2}>Add Project - Step 9</Title>
        <div className="addtowers-form">
          <Form.Item label="Project Start Date" required>
  <DatePicker
    value={projectStartDate ? dayjs(projectStartDate) : null}
    onChange={date => setProjectStartDate(date)}
  />
</Form.Item>

<Form.Item label="Project End Date" required>
  <DatePicker
    value={projectEndDate ? dayjs(projectEndDate) : null}
    onChange={date => setProjectEndDate(date)}
  />
</Form.Item>

          {phases.map((phase, index) => (
            <div key={index} className="phase-block" style={{ marginBottom: 32, borderBottom: '1px solid #eee', paddingBottom: 16 }}>
              <Title level={4}>Phase {index + 1}</Title>

              <Form.Item label="Phase Name">
                <Input
                  value={phase.name}
                  onChange={e => handlePhaseChange(index, 'name', e.target.value)}
                />
              </Form.Item>

              <Space style={{ marginBottom: 8 }}>
                <Form.Item label="Start Date">
                  <DatePicker
                    value={phase.startDate ? dayjs(phase.startDate) : null}
                    onChange={date => handlePhaseChange(index, 'startDate', date)}
                  />
                </Form.Item>

                <Form.Item label="End Date">
                  <DatePicker
                    value={phase.endDate ? dayjs(phase.endDate) : null}
                    onChange={date => handlePhaseChange(index, 'endDate', date)}
                  />
                </Form.Item>
              </Space>

              <Divider orientation="left">Scheme</Divider>

              {phase.scheme.map((s, sIdx) => (
                <Space key={sIdx} align="baseline" style={{ display: 'flex', marginBottom: 8 }}>
                  <Form.Item label="Percent">
                    <InputNumber
                      value={s.percent}
                      min={0}
                      max={100}
                      onChange={value => handleSchemeChange(index, sIdx, 'percent', value)}
                    />
                  </Form.Item>
                  <Form.Item label="Days">
                    <InputNumber
                      value={s.days}
                      min={0}
                      onChange={value => handleSchemeChange(index, sIdx, 'days', value)}
                    />
                  </Form.Item>
                  {phase.scheme.length > 1 && (
                    <MinusCircleOutlined onClick={() => handleRemoveScheme(index, sIdx)} />
                  )}
                </Space>
              ))}

              <Button
                type="dashed"
                icon={<PlusOutlined />}
                onClick={() => handleAddScheme(index)}
              >
                Add Scheme
              </Button>

              {phases.length > 1 && (
                <Button
                  danger
                  type="link"
                  onClick={() => handleRemovePhase(index)}
                  style={{ marginTop: 8 }}
                >
                  Remove Phase
                </Button>
              )}
            </div>
          ))}

          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleAddPhase}
            style={{ marginBottom: 24 }}
          >
            Add Phase
          </Button>

          <br />
          <Button type="primary" onClick={handleSubmit}>
            Submit All Phases
          </Button>
        </div>
      </div>
    </>
  );
};

export default Addtowerstep9;
